import { User } from "common/user.interface";
import { createContext } from "react";

const UserContext = createContext<User>(null);

export default UserContext